import request from '@/request'

export async function getTimelineIndex (params) {
  return await request({
    url: `/timeline?page`,
    method: 'get',
    params
  })
}

export async function getTimelineActivitiesByUser (userId, { page }) {
  return await request({
    url: `/users/${userId}/timeline/activities?page=${page}`,
    method: 'get'
  })
}